// @flow
import React, { Component } from "react";
import MapPin from "react-feather/dist/icons/map-pin";
import styles from "./MapButton.module.css";

type Props = {
  onClick: Event => void,
  isMapFullscreen: boolean
};

type State = {};

class MapButton extends Component<Props, State> {
  render() {
    const { onClick, isMapFullscreen, ...restProps } = this.props;
    return (
      <div className={styles.wrapper}>
        <button
          type="button"
          className={styles.button}
          onClick={onClick}
          {...restProps}
        >
          {isMapFullscreen ? `Minimize Map` : `View Map`} <MapPin height={14} />
        </button>
      </div>
    );
  }
}

export default MapButton;



// WEBPACK FOOTER //
// ./src/components/Landing/MapButton/MapButton.js